class DisplaySuggestionsUpgradeController {

    $onInit () {
        if (this.items && !this.item) {
            this.item = this.items[0];
        }

        this.unavailable = false;
    }

    itemIs (type) {
        if (!this.item || (!this.item.upgraded && !this.upgrade)) {
            this.unavailable = true;
            return false;
        }

        if (this.upgrade && this.upgrade.availability && !this.upgrade.availability.available) {
            this.unavailable = true;
            return false;
        }

        if (type === 'Treatment' && this.item.item.type_name === 'OptionGroupOption') {
            return this.item.item.option_id > 0;
        }

        if (type === 'OptionGroupOption' && this.item.item.option_id > 0) {
            return false;
        }

        return this.item &&
            this.item.item &&
            this.item.item.type_name === type;
    }

    showUpgrade () {
        // Don't show upgrades to linked integrated treatments
        return !!(this.item && !this.item.item.option_is_integrated);
    }
}


export default DisplaySuggestionsUpgradeController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/checkout/controllers/display.suggestions.upgrade.controller.js